module.exports = "<!-- Back to home -->\n<div class=\"back-home\">\n  <button type=\"button\" class=\"btn btn-sm pl-0 ml-0 mb-3\" [routerLink]=\"'..'\">\n    <span><i class=\"icon icon-arrow-back-breadcrumb mr-1\" aria-hidden=\"true\"></i>HOME</span>\n  </button>\n</div>\n\n<!-- Search info -->\n<div class='search-info mt-2 mb-sm-2'>\n\n</div>\n\n<!-- Search dashboard -->\n<div class=\"search-dashboard mb-5\">\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/search/search.component.html
// module id = ./src/app/views/search/search.component.html
// module chunks = main